import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';
import GalleryArrow from 'shared-vectors/icons/GalleryArrow';
import { Icon } from 'shared-vectors';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

const Arrows = ({
  infinite,
  current,
  total,
  goToPrev,
  goToNext,
}) => {
  const cls = useStyles();

  let showPrev = infinite;
  if (!showPrev) {
    showPrev = current > 0;
  }

  let showNext = infinite;
  if (!showNext) {
    showNext = current < total - 1;
  }

  return (
    <>
      {
        showPrev
          && (
            <div className={cls[mainCls]} onClick={goToPrev}>
              <Icon name={GalleryArrow} color="w" />
            </div>
          )
      }
      {
        showNext
          && (
            <div className={`${cls[mainCls]} next`} onClick={goToNext}>
              <Icon name={GalleryArrow} className="is-rot-180" color="w" />
            </div>
          )
      }
    </>
  );
};

export default Arrows;

Arrows.propTypes = {
  infinite: PropTypes.bool,
  current: PropTypes.number,
  total: PropTypes.number,
  goToPrev: PropTypes.func,
  goToNext: PropTypes.func,
};
Arrows.defaultProps = {
  infinite: false,
  current: 1,
  total: 0,
  goToPrev: () => {},
  goToNext: () => {},
};